import React from "react";

import { ControlReviewService } from "@egis-smartcity/parking";

export type ControlReviewState = {
  controlReviewService?: ControlReviewService;
};

export const ControlReviewContext = React.createContext<
  ControlReviewState | undefined
>(undefined);

export default ControlReviewContext;
